import React from 'react';

// Heroicons has no brand marks, so these are small hand-rolled SVGs kept in
// one place rather than pulling in a whole icon-pack dependency for two icons.
export function FacebookIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
    </svg>
  );
}

export function InstagramIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect x="2.5" y="2.5" width="19" height="19" rx="5" />
      <path d="M16.5 11.37a4.5 4.5 0 1 1-8.99-.74 4.5 4.5 0 0 1 8.99.74z" />
      <path d="M17.5 6.5h.01" />
    </svg>
  );
}
